import { render, staticRenderFns } from "./EventPage.vue?vue&type=template&id=558e17ee&scoped=true&"
import script from "./EventPage.vue?vue&type=script&lang=ts&"
export * from "./EventPage.vue?vue&type=script&lang=ts&"
import style0 from "./EventPage.vue?vue&type=style&index=0&id=558e17ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558e17ee",
  null
  
)

export default component.exports